import { render, staticRenderFns } from "./ComparePlanCard.vue?vue&type=template&id=0e591112"
import script from "./ComparePlanCard.vue?vue&type=script&lang=js"
export * from "./ComparePlanCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports